module.exports = __webpack_public_path__ + "images/TacoBouncer.656dc3a1db8d11cde974.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/TacoBouncer.png
// module id = +0bn
// module chunks = 2